import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowQuickInfo: false,
    shallShowOverlay: false,
    shallShowLoadingAnimation: false,
    shallShowLoadingLayout: false,
    shallShowNetworkError: false,
    pageDidLoad: false,
    photosToPreview: null,
    networkError: null,
    unauthenticatedErrorCounter: 0,
    componentToKeepAlive: null,
    openedModal: null,
    socialMediaAuthInProgress: false,
    openOrganizationSwitch: false,
    organizationJustJoined: false,
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state

      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'

      return 'xs'
    },

    windowWidth: (state) => state.windowWidth,

    shallShowOverlay: (state) => state.shallShowOverlay,

    shallShowQuickInfo: (state) => state.shallShowQuickInfo,

    shallShowLoadingAnimation: (state) => state.shallShowLoadingAnimation,

    shallShowLoadingLayout: (state) => state.shallShowLoadingLayout,

    pageDidLoad: (state) => state.pageDidLoad,

    photosToPreview: (state) => state.photosToPreview,

    networkError: (state) => state.networkError,

    unauthenticatedErrorCounter: (state) => state.unauthenticatedErrorCounter,

    componentToKeepAlive: (state) => state.componentToKeepAlive,

    openedModal: (state) => state.openedModal,

    socialMediaAuthInProgress: (state) => state.socialMediaAuthInProgress,
  },
  mutations: {
    LOAD_PHOTOS_TO_PREVIEW(state, photos) {
      state.photosToPreview = photos
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    TOGGLE_QUICK_INFO(state, val) {
      state.shallShowQuickInfo = val !== undefined ? val : !state.shallShowQuickInfo
    },
    TOGGLE_LOADING_ANIMATION(state, val) {
      state.shallShowLoadingAnimation =
        val !== undefined ? val : !state.shallShowLoadingAnimation
    },
    TOGGLE_LOADING_LAYOUT(state, val) {
      state.shallShowLoadingLayout =
        val !== undefined ? val : !state.shallShowLoadingLayout
    },

    SET_PAGE_DID_LOAD(state, val) {
      state.pageDidLoad = val
    },

    UPDATE_COMPONENT_TO_KEEP_ALIVE(state, val) {
      state.componentToKeepAlive = val
    },

    UPDATE_OPENED_MODAL(state, val) {
      state.openedModal = val
    },

    RESET_NETWORK_ERROR(state, val) {
      state.shallShowNetworkError = false
      state.networkError = null
    },

    INCREASE_UNAUTHENTICATED_ERROR_COUNTER(state, val) {
      state.unauthenticatedErrorCounter++
    },

    RESET_UNAUTHENTICATED_ERROR_COUNTER(state, val) {
      state.unauthenticatedErrorCounter = 0
    },

    SET_OPEN_ORGANIZATION_SWITCH(state, val) {
      state.openOrganizationSwitch = val
    },

    SET_ORGANIZATION_JUST_JOINED(state, val) {
      state.organizationJustJoined = val
    },

    DISPLAY_NETWORK_ERROR(state, val) {
      if (state.shallShowNetworkError === val) return

      state.shallShowNetworkError = val

      if (state.shallShowNetworkError) {
        state.networkError = 'Offline. Your network is unavailable.'
      } else {
        state.networkError = null
      }
    },

    SET_SOCIAL_MEDIA_AUTH_IN_PROGRESS(state, val) {
      state.socialMediaAuthInProgress = val
    },
  },
  actions: {
    setOpenOrganizationSwitch({ commit }, value) {
      commit('SET_OPEN_ORGANIZATION_SWITCH', value)
    },
  },
}
